const gendersSpectrum = ['#315A5E', '#ED6A5A'];

export { gendersSpectrum };